module.exports = __webpack_public_path__ + "static/media/link.6d16eaa3.svg";